import React, { useState, useRef, useEffect } from "react";
import { Image, Col, Form, Row, Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import Switch from "react-switch";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import { useFormik } from "formik";
import * as yup from "yup";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import moment from "moment";
import axios from "axios";
import {
  serverApi,
  videoUploadSize,
  imageUploadSize,
} from "../../../../config/Keys";
import Alert from "react-s-alert";
import AlertDialogProgress from "../../../reusableComponents/allPopupReusable/DialogProgression";
import InputNumberFunc from "../../../../function/InputNumberFunc";
import { OFFER_ACTIVE_SERVICE } from "../../../../enums/GlobalEnums";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { vendor_update_offer } from "../../../../store/actions/vendorOffersAndEventsAction";
import isEmpty from "../../../../store/validation/is-Empty";
import Media from "react-media";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import SimpleReactLightbox from "simple-react-lightbox";
import MultipleImageUploadComponent from "../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { errorAlert } from "../../../../function/alert";

const VendorEditOnlineOffer = (props) => {
  //state
  let history = useHistory();
  const [active, setActive] = useState({ active: false });
  const [selectedTab, setSelectedTab] = useState(1);
  const [showAll, setShowAll] = useState(false);
  const [showSkipTheLine, setShowSkipTheLine] = useState(false);
  const [showTakeAway, setShowTakeAway] = useState(false);
  const [showCurbSide, setShowCurbSide] = useState(false);
  const [showDineIn, setShowDineIn] = useState(false);
  const [showCatering, setShowCatering] = useState(false);
  const [showDelivery, setShowDelivery] = useState(false);
  const [activeService, setActiveService] = useState([]);
  const [removeActiveService, setRemoveActiveService] = useState([]);

  const percentArr = [
    {
      id: 0,
      value: true,
      title: "Percentage of Order Value",
      type: 'PERCENTAGE'
    },
    {
      id: 1,
      value: false,
      title: "Fixed Amount on Order Value",
      type: "FIXED"
    },
    {
      id: 2,
      value: false,
      title: "Discounted Delivery",
      type: "DELIVERY"
    },
  ];

  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const [primaryOffer, setPrimaryOffer] = useState({ primaryOffer: false });
  const markAsPrimary = (data) => (e) => {
    // setPrimaryOffer({ primaryOffer: !primaryOffer.primaryOffer });
    if (state.hidden && !primaryOffer.primaryOffer) {
      return errorAlert('Remove hidden toggle to Make Primary')
    }
    if (data === false || data === undefined) {
      setPrimaryOffer({ primaryOffer: true });
      setActive({ active: true });
    } else {
      setPrimaryOffer({ primaryOffer: !primaryOffer.primaryOffer });
    }
  };
  const toggleFunction = (e) => {
    setActive({ active: !active.active });
  };

  const toggleDelivery = (e) => {
    formik2.setFieldValue('isDelivery', !formik2.values.isDelivery);
  };

  const [state, setState] = useState({
    restaurant_pictures: [],
    restaurant_pictures_new: [],
    restaurant_video: [],
    video_url: "",
    progress: 0,
    actionButton: false,
    hidden: false,
    isPercentage: true,
    type: 'PERCENTAGE',
    isDelivery: false,
    allRestaurantServices: [],
    removeAllServices: [],
    selectedRestaurantService: [],
    errors: {},
  });

  useEffect(() => {
    if (
      props?.servicesEnabled?.cubside_delivery?.value ||
      props?.servicesEnabled?.self_serve?.value ||
      props?.servicesEnabled?.dine_in_order?.value ||
      props?.servicesEnabled?.take_away?.value ||
      props?.servicesEnabled?.catering_banquet?.value ||
      props?.servicesEnabled?.home_delivery?.value
    ) {
      setShowAll(true);
    }

    if (props?.servicesEnabled?.cubside_delivery?.value) {
      setShowCurbSide(true);
    }
    if (props?.servicesEnabled?.self_serve?.value) {
      setShowSkipTheLine(true);
    }
    if (props?.servicesEnabled?.dine_in_order?.value) {
      setShowDineIn(true);
    }
    if (props?.servicesEnabled?.take_away?.value) {
      setShowTakeAway(true);
    }
    if (props?.servicesEnabled?.catering_banquet?.value) {
      setShowCatering(true);
    }
    if (props?.servicesEnabled?.home_delivery?.value) {
      setShowDelivery(true);
    }
  }, [props.servicesEnabled, props.sessionSettings, props.onboarding]);

  useEffect(() => {
    let allActiveService = OFFER_ACTIVE_SERVICE;
    let selectedService = [];
    let selectedRemoveService = [];
    for (let i = 0; i < allActiveService.length; i++) {
      if (allActiveService[i].name === "All") {
        allActiveService[i].show = showAll;
      }
      if (allActiveService[i].name.toString() === "Takeaway") {
        allActiveService[i].show = showTakeAway;
      }
      if (allActiveService[i].name.toString() === "Curbside") {
        allActiveService[i].show = showCurbSide;
      }
      if (allActiveService[i].name.toString() === "Skip the line") {
        allActiveService[i].show = showSkipTheLine;
      }
      if (allActiveService[i].name.toString() === "Dine-In") {
        allActiveService[i].show = showDineIn;
      }
      if (allActiveService[i].name.toString() === "Catering") {
        allActiveService[i].show = showCatering;
      }
      if (allActiveService[i].name.toString() === "Delivery") {
        allActiveService[i].show = showDelivery;
      }
    }
    allActiveService.filter((ele) => {
      if (ele.show) {
        return selectedService.push(ele);
      }
    });
    allActiveService.filter((ele) => {
      if (ele.show && ele.name.toString() !== "All") {
        return selectedRemoveService.push(ele);
      }
    });
    setActiveService(selectedService);
    setRemoveActiveService(selectedRemoveService);
  }, [
    showAll,
    showTakeAway,
    showDineIn,
    showCurbSide,
    showSkipTheLine,
    showCatering,
    showDelivery,
  ]);

  useEffect(() => {
    setState({
      ...state,
      allRestaurantServices: activeService,
      removeAllServices: removeActiveService,
    });
  }, [activeService, removeActiveService]);

  /*********************************************
   * @DESC - Applicable Service Action
   *********************************************/
  const aplicableServices = (icon) => {
    let allRestaurantServices = state.allRestaurantServices;
    let removeAllServices = state.removeAllServices;
    let Restaurant = state.selectedRestaurantService;
    let allArray = [];
    // if (Restaurant.length === 0) {
    //   Restaurant.push(icon.name);
    //   setState({
    //     ...state,
    //     selectedRestaurantService: Restaurant,
    //   });
    // } else {
    // }
    let isAlreadyPresent = Restaurant.includes(icon.name);
    if (icon.name === "All") {
      let indexOf = Restaurant.indexOf(icon.name);
      if (isAlreadyPresent) {
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        allArray.push("All");
        if (showTakeAway) {
          allArray.push("Takeaway");
        }
        if (showCurbSide) {
          allArray.push("Curbside");
        }
        if (showSkipTheLine) {
          allArray.push("Skip the line");
        }
        if (showDineIn) {
          allArray.push("Dine-In");
        }
        if (showCatering) {
          allArray.push("Catering");
        }
        if (showDelivery) {
          allArray.push("Delivery");
        }
      }
    } else if (isAlreadyPresent) {
      if (
        allRestaurantServices.every((elem) => Restaurant.includes(elem.name))
      ) {
        for (var i = 0; i < Restaurant.length; i++) {
          if (Restaurant[i] === icon?.name) {
            Restaurant.splice(i, 1);
          }
          if (Restaurant[i].toString() === "All") {
            Restaurant.splice(i, 1);
          }
        }
      } else {
        for (var i = 0; i < Restaurant.length; i++) {
          if (Restaurant[i].toString() === icon?.name.toString()) {
            Restaurant.splice(i, 1);
          }
        }
      }
    } else {
      Restaurant.push(icon.name);
      if (removeAllServices.every((elem) => Restaurant.includes(elem.name))) {
        Restaurant.push("All");
      }
    }
    setState({
      ...state,
      selectedRestaurantService: icon.name === "All" ? allArray : Restaurant,
    });
    formik2.setFieldValue(
      "service_type",
      icon.name === "All" ? allArray : Restaurant
    );
  };

  const handleCheckbox = (e) => {
    setState({
      ...state,
      isPercentage: !state.isPercentage,
    });
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/

  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = state.restaurant_pictures;
    let restaurant_pictures_temp = state.restaurant_pictures_new;

    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    oldData.push(e);
    setState({
      ...state,
      restaurant_pictures_new: newToUpload,
      restaurant_pictures: oldData,
      actionButton: true,
    });
  };
  const uploadMultipleFiles = (e) => {
    const vendor_id = props.auth.user.VendorUser._id;
    const restaurant_name = props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    var newUploaded = [];
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > imageUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else if (e.target.files.length > 10) {
        alert("You can upload only 10 files");
        return (flag = false);
      } else {
        let allPicures = state.restaurant_pictures;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            return (flag = true);
          } else {
            return (flag = false);
          }
        });
        if (!flag) {
          newUploaded.push(e.target.files[i]);
          data.append("files", e.target.files[i]);
        }
      }
    }
    if (!flag) {
      setState({
        ...state,
        restaurant_pictures_new: newUploaded,
        combined: combined,
      });
    } else {
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    e.target.value = "";
  };

  const multipleResetFile = (indexId) => {
    let allPicures = state.restaurant_pictures;
    let allPicuresObj = allPicures.find((images, index) => index === indexId);
    if (allPicuresObj === 0 || allPicuresObj) {
      allPicures.splice(allPicures.indexOf(allPicuresObj), 1);
      setState({ ...state, allPicures: allPicures, actionButton: true });
    }
  };

  /*************************************
   * @DESC Multiple Video Upload
   ************************************/
  const uploadMultipleVideoFiles = (e) => {
    e.preventDefault();
    const vendor_id = props.auth.user.VendorUser._id;
    const restaurant_name = props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > videoUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else {
        if (state.restaurant_video && state.restaurant_video.length > 0) {
          if (state.restaurant_video[0].name === e.target.files[i].name) {
            return (flag = true);
          }
        }
        if (!flag) {
          data.append("file", e.target.files[i]);
        }
      }
    }
    // ?uploadSide=${combined}
    var newData = e.target.files;
    if (!flag) {
      const setProgress = (percent) => {
        setState({
          ...state,
          progress: percent,
        });
      };
      axios
        .post(`${serverApi}/upload-assets-video`, data, {
          onUploadProgress: (progressEvent) => {
            setProgress((progressEvent.loaded / progressEvent.total) * 100);
          },
        })
        .then((res) => {
          setState({
            ...state,
            video_url: "",
          });
          setState({
            ...state,
            restaurant_video: newData,
            video_url: res.data,
            actionButton: true,
          });
          Alert.success(`<h4>Offer Video Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      Alert.error(`<h4>Can not upload the same video</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    e.target.value = "";
  };

  const multipleVideoResetFile = (e) => {
    let video_url = state.video_url;
    let restaurant_video = state.restaurant_video;
    video_url = "";
    restaurant_video = [];
    setState({
      ...state,
      restaurant_video: restaurant_video,
      video_url: video_url,
      actionButton: true,
    });
  };

  const onSuccessAddOffer = (e) => {
    history.push("/offer");
  };

  const formik1 = useFormik({
    initialValues: {
      vendor_id: "",
      name: "",
      description: "",
      start_date: "",
      start_time: "",
      hidden: false,
      end_date: "",
      end_time: "",
      coupon_code: "",
      maximum_usage_limit: "",
      photos: [],
      videos: [],
      terms_and_condition: "",
      refund_and_cancellation: "",
      isOnline: true,
      isGlobal: false,
      pointOfEntry: "VENDOR",
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .required("Offer name is required")
        .min(1, "Minimum 1 Character")
        .max(64, "Maximum 64 Character"),
      description: yup
        .string()
        .required("Description is required")
        .min(1, "Minimum 1 Character")
        .max(512, "Maximum 512 Character"),
      start_date: yup.string().required("Start date is required"),
      start_time: yup.string().required("Start time is required"),
      end_date: yup.string().required("End date is required"),
      end_time: yup.string().required("End time is required"),
      coupon_code: yup
        .string()
        .required("Coupon code is required")
        .min(1, "Minimum 1 Character")
        .max(16, "Maximum 15 Character"),
      maximum_usage_limit: yup
        .number()
        .required("Maximum usage limit is required"),
      terms_and_condition: yup
        .string()
        .required("Terms and condtion  is required")
        .min(1, "Minimum 1 Character")
        .max(512, "Maximum 512 Character"),
      refund_and_cancellation: yup
        .string()
        .required("refund and cancellation is required")
        .min(1, "Minimum 1 Character")
        .max(512, "Maximum 512 Character"),
    }),

    onSubmit: (values) => {
      const arr3 = [];
      const arr1 = state.removeAllServices;
      for (let i = 0; i < arr1.length; i++) {
        arr3.push(arr1[i].name);
      }
      const arr2 = state.selectedRestaurantService;
      let service = nextButtonOffer(arr3, arr2);
      if (service) {
        arr2.push("All");
        setState({
          ...state,
          selectedRestaurantService: arr2,
        });
      } else {
        setState({
          ...state,
          selectedRestaurantService: arr2,
        });
      }
      handleTab(2);
    },
  });

  const nextButtonOffer = (arr3, arr2) => {
    return (
      Array.isArray(arr3) &&
      Array.isArray(arr2) &&
      arr3.length === arr2.length &&
      arr3.every((val, index) => arr2.includes(val))
    );
  };

  const formik2 = useFormik({
    initialValues: {
      isPercentage: true,
      isDelivery: false,
      deliveryMinOrder: "",
      deliveryMaxDiscount: "",
      hidden: false,
      discount: "",
      minimum_order_applied: "",
      maximum_order_applied: "",
      maximum_discount_applied: "",
      service_type: [],
      type: "PERCENTAGE",
      isDelivery: false,
      deliveryMinOrder: 0,
      deliveryMaxDiscount: "",
    },
    validationSchema: yup.object({
      discount: yup
        .number()
        .when("isPercentage", {
          is: true,
          then: yup
            .number(),
            // .lessThan(
            //   yup.ref("minimum_order_applied"),
            //   "Discount value must be less than minimum order value"
            // ),
          otherwise: yup
            .number()
            .lessThan(
              yup.ref("minimum_order_applied"),
              "Discount value must be less than minimum order value"
            ),
        })
        .min(1, "value must be greater than or equal to 1"),
      minimum_order_applied: yup
        .number()
        .min(1, "Minimum Order Value must be greater than or equal to 1")
        .required("Minimum Order Value is required"),
      maximum_order_applied: yup
        .number()
        .min(1, "Maximum Order Value must be greater than or equal to 1")
        .moreThan(
          yup.ref("minimum_order_applied"),
          "Maximum Order Value must be greater than Minimum Order Value"
        ),
      maximum_discount_applied: yup.number().when(["type", "isPercentage"], {
        is: (type, isPercentage) => type !== "DELIVERY" && isPercentage,
        then: yup.number().required("Maximum Discount Value is required"),
      }),
      deliveryMaxDiscount: yup.number().when(["type", 'isDelivery'], {
        is: (type, isDelivery) => type === "DELIVERY" || isDelivery,
        then: yup.number().required("Maximum Delivery Discount Value is required"),
      }),
      // .lessThan(
      //   yup.ref("maximum_order_applied"),
      //   "Maximum discount value must be less than maximum order value"
      // ),
      service_type: yup.array().min(1, "Atleast one Service Type is required"),
    }),

    onSubmit: (values) => {
      // let perpareData = {};
      var formData = {};
      const startDate = {
        start_date: moment(
          formik1.values.start_date + "T" + formik1.values.start_time
        ).toISOString(),
      };
      const end_Date = {
        end_date: moment(
          formik1.values.end_date + "T" + formik1.values.end_time
        ).toISOString(),
      };

      let day_you_eat_out = [];
      for (let i = 0; i < state.selectedRestaurantService.length; i++) {
        if (state.selectedRestaurantService[i] === "All") {
          state.selectedRestaurantService.splice(i, 1);
          day_you_eat_out.push(state.selectedRestaurantService[i]);
        } else {
          day_you_eat_out.push(state.selectedRestaurantService[i]);
        }
      }

      formData.name = formik1.values.name;
      formData.description = formik1.values.description;
      formData.coupon_code = formik1.values.coupon_code.toUpperCase();
      formData.start_date = startDate.start_date;
      formData.end_date = end_Date.end_date;
      formData.hidden = state.hidden;
      formData.maximum_usage_limit = formik1.values.maximum_usage_limit;
      formData.photos = state.restaurant_pictures;
      formData.offerVideo = state.video_url;
      formData.terms_and_condition = formik1.values.terms_and_condition;
      formData.refund_and_cancellation = formik1.values.refund_and_cancellation;
      formData.active = active.active;
      formData.mark_as_primary = primaryOffer.primaryOffer;
      formData.send_to_carousel = false;
      formData.isGlobal = formik1.values.isGlobal;
      formData.vendor_id = props.auth.user.VendorUser._id;
      formData.isOnline = formik1.values.isOnline;
      formData.pointOfEntry = formik1.values.pointOfEntry;
      formData.isPercentage = state.isPercentage;
      formData.isDelivery = values.isDelivery;
      formData.deliveryMinOrder = values.deliveryMinOrder;
      formData.deliveryMaxDiscount = values.deliveryMaxDiscount;
      formData.type = state.type; 
      formData.discount = values.discount;
      formData.minimum_order_applied = values.minimum_order_applied;
      formData.maximum_order_applied = values.maximum_order_applied;
      formData.maximum_discount_applied = values.maximum_discount_applied;
      formData.service_type = values.service_type;
      const token = props.auth.user.accessToken;
      const offerId = editData._id;
      if (formik2.values.type !== 'DELIVERY') {
        if (formik2.values.isPercentage && formik2.values.discount === "") {
          formik2.setErrors({
            discount: "Discount Percentage is required",
          });
        } else if (
          !formik2.values.isPercentage &&
          formik2.values.discount === ""
        ) {
          formik2.setErrors({
            discount: "Discount Amount is required",
          });
        }
      }
      if (isEmpty(formik2.errors)) {
        props.vendor_update_offer(formData, offerId, token, onSuccessAddOffer);
      }
    },
  });

  const isPercentageAction = (value) => {
    if (value === 'PERCENTAGE') formik2.setFieldValue("isPercentage", true);
    else if (value === 'FIXED') formik2.setFieldValue("isPercentage", false);

    formik2.setFieldValue("type", value)
    setState({
      ...state,
      type: value
    });
    formik2.setFieldValue("discount", "");
  };

  const hiddenAction = (value) => {
    if (value === true && primaryOffer?.primaryOffer === true) {
      return errorAlert('Remove Primary to make offer Hidden')
    }
    formik2.setFieldValue("hidden", value);
    setState({
      ...state,
      hidden: value,
    });
  };

  const [count, setCount] = useState(1);
  const [count2, setCount2] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik1.handleSubmit();
  };

  const onClickSave2 = () => {
    setCount2(count2 + 1);
    formik2.handleSubmit();
  };

  useEffect(() => {
    formik1.setFieldValue("name", "");
  }, []);
  // for set focus
  useEffect(() => {
    if (formik1.errors && formik1.errors.name) {
      let nameElement = document.getElementById("name");
      nameElement.focus();
    } else if (formik1.errors && formik1.errors.description) {
      let descElement = document.getElementById("description");
      descElement.focus();
    } else if (formik1.errors && formik1.errors.start_date) {
      let startDateElement = document.getElementById("start_date");
      startDateElement.focus();
    } else if (formik1.errors && formik1.errors.start_time) {
      let startTimeElement = document.getElementById("start_time");
      startTimeElement.focus();
    } else if (formik1.errors && formik1.errors.end_date) {
      let endDateElement = document.getElementById("end_date");
      endDateElement.focus();
    } else if (formik1.errors && formik1.errors.end_time) {
      let endTimeElement = document.getElementById("end_time");
      endTimeElement.focus();
    } else if (formik1.errors && formik1.errors.coupon_code) {
      let couponCodeElement = document.getElementById("coupon_code");
      couponCodeElement.focus();
    } else if (formik1.errors && formik1.errors.maximum_usage_limit) {
      let maximum_usage_limitElement = document.getElementById(
        "maximum_usage_limit"
      );
      maximum_usage_limitElement.focus();
    } else if (formik1.errors && formik1.errors.terms_and_condition) {
      let termAndCondtionsElement = document.getElementById(
        "terms_and_condition"
      );
      termAndCondtionsElement.focus();
    } else if (formik1.errors && formik1.errors.refund_and_cancellation) {
      let refund_and_cancellationElement = document.getElementById(
        "refund_and_cancellation"
      );
      refund_and_cancellationElement.focus();
    }
  }, [count]);


  const useStyles = makeStyles((theme) => ({
    formControl: {
      minWidth: "100%",
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));

  const [minDate, setMinDate] = useState("");
  const [minEndDate, setMinEndDate] = useState("");
  const handleStartDateChange = (e) => {
    formik1.setFieldValue("start_date", e.target.value);
    formik1.setFieldValue("end_date", "");
    setMinEndDate(e.target.value);
  };
  useEffect(() => {
    let data = moment().format("YYYY-MM-DD");
    setMinDate(data);
  }, []);

  const [days, setDays] = useState([
    { name: "All", status: false },
    { name: "Takeaway", status: false },
    { name: "Dine-In", status: false },
    { name: "Curbside", status: false },
    // { name: "Catering", status: false },
    { name: "Delivery", status: false },
    // { name: "Skip the line", status: false },
  ]);

  const [days1, setDays1] = useState([
    { name: "All", status: false },
    { name: "Takeaway", status: false },
    { name: "Curbside", status: false },
    { name: "Skip the line", status: false },
    // { name: "Catering", status: false },
    { name: "Delivery", status: false },
  ]);

  const daysEatOut = (editData) => {
    var data = editData.service_type;
    var daysRecord = props.subscriptionData?.fast_food_dining ? days1 : days;
    var pushTrueDays = [];
    for (var i = 0; i < daysRecord.length; i++) {
      if (data.includes(daysRecord[i].name)) {
        pushTrueDays.push({ name: daysRecord[i].name, status: true });
      } else {
        pushTrueDays.push({ name: daysRecord[i].name, status: false });
      }
    }
    props.subscriptionData?.fast_food_dining
      ? setDays1(pushTrueDays)
      : setDays(pushTrueDays);
  };

  const onChangeDaysEatOut = (day) => {
    var daysRecord = props.subscriptionData?.fast_food_dining ? days1 : days;
    if (day.name === "All") {
      //setRemoveOtherDays(false);
      var removeOtherDays =
        daysRecord &&
        daysRecord.map((data) => {
          if (data.name !== "All") {
            return { ...data, status: false };
          } else {
            return { ...data, status: true };
          }
        });
      props.subscriptionData?.fast_food_dining
        ? setDays1(removeOtherDays)
        : setDays(removeOtherDays);
      //setDaysEatOut([day.name]);
    } else {
      var changeDayStatus =
        daysRecord &&
        daysRecord.map((data) => {
          if (data.name === day.name) {
            return { ...data, status: !data.status };
          } else if (data.name === "All") {
            return { ...data, status: false };
          } else {
            return { ...data };
          }
        });
      props.subscriptionData?.fast_food_dining
        ? setDays1(changeDayStatus)
        : setDays(changeDayStatus);
    }
    formik2.setErrors({ service_type: "" });
  };

  useEffect(() => {
    if (history.location && history.location.state) {
      setEditData(history.location.state.editData);
    }
  }, [history.location && history.location.state]);

  const [editData, setEditData] = useState({});

  useEffect(() => {
    if (editData.name) {
      formik1.setFieldValue("name", editData.name);
    }
    if (editData.description) {
      formik1.setFieldValue("description", editData.description);
    }
    if (editData.coupon_code) {
      formik1.setFieldValue("coupon_code", editData.coupon_code);
    }
    if (editData.maximum_usage_limit) {
      formik1.setFieldValue(
        "maximum_usage_limit",
        editData.maximum_usage_limit
      );
    }
    if (editData.terms_and_condition) {
      formik1.setFieldValue(
        "terms_and_condition",
        editData.terms_and_condition
      );
    }
    if (editData.refund_and_cancellation) {
      formik1.setFieldValue(
        "refund_and_cancellation",
        editData.refund_and_cancellation
      );
    }
    if (editData && editData.photos) {
      setState({
        ...state,
        restaurant_pictures: !isEmpty(editData?.photos) ? editData?.photos : [],
        video_url: !isEmpty(editData.offerVideo) ? editData.offerVideo : "",
        hidden: editData.hidden || false,
        isPercentage: !isEmpty(editData.isPercentage)
          ? editData.isPercentage
          : false,
      });
    }
    if (editData.mark_as_primary) {
      setPrimaryOffer({ primaryOffer: editData.mark_as_primary });
    }
    if (editData.start_date) {
      let startD = editData.start_date.split("T")[0];
      formik1.setFieldValue(`start_date`, startD);
      let startT = moment(editData.start_date).format("HH:mm");
      formik1.setFieldValue(`start_time`, startT);
    }
    if (editData.end_date) {
      let endD = editData.end_date.split("T")[0];
      formik1.setFieldValue(`end_date`, endD);
      let endT = moment(editData.end_date).format("HH:mm");
      formik1.setFieldValue(`end_time`, endT);
    }
    if (editData.active) {
      setActive({ active: editData.active });
    }
    if (editData.discount) {
      formik2.setFieldValue("discount", editData.discount);
    }
    if (editData && editData.minimum_order_applied) {
      formik2.setFieldValue(
        "minimum_order_applied",
        editData && editData.minimum_order_applied
      );
    }
    if (editData && editData.maximum_order_applied) {
      formik2.setFieldValue(
        "maximum_order_applied",
        editData && editData.maximum_order_applied
      );
    }
    if (editData && editData.maximum_discount_applied) {
      formik2.setFieldValue(
        "maximum_discount_applied",
        editData && editData.maximum_discount_applied
      );
    }
    if(editData?.deliveryMinOrder) formik2.setFieldValue('deliveryMinOrder', editData?.deliveryMinOrder);
    if(editData?.deliveryMaxDiscount) formik2.setFieldValue('deliveryMaxDiscount', editData?.deliveryMaxDiscount);
    if (editData.service_type) {
      formik2.setFieldValue(`service_type`, editData?.service_type);
    }
    if (editData.isPercentage) {
      formik2.setFieldValue(`isPercentage`, editData?.isPercentage);
    }
    if (editData.type) formik2.setFieldValue('type', editData?.type);
    if (editData && editData.service_type) {
      let arrService = editData?.service_type;
      setState({
        ...state,
        selectedRestaurantService: arrService,
        restaurant_pictures: !isEmpty(editData?.photos) ? editData?.photos : [],
        video_url: !isEmpty(editData.offerVideo) ? editData.offerVideo : "",
        hidden: editData.hidden,
        isPercentage: !isEmpty(editData.isPercentage)
          ? editData?.isPercentage
          : false,
        type: editData?.type || "PERCENTAGE"
      });
    }
  }, [editData]);

  let daysRecords = props.subscriptionData?.fast_food_dining ? days1 : days;

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={2} />
          </div>
          <div className="super-admin-right-side-panel">
            <div className="super-admin-inside-right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/offer"
                displayText="back"
                noEnAdminPic={true}
              />
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Edit Offer</div>
              </div>

              <div className="d-flex align-items-start">
                <div className={`enAddOffersOPtion `}>
                  <Image
                    src={require("../../../../assets/images/UserManagement/onlineActiveOffer.svg")}
                    alt="View"
                    title="View"
                    fluid
                    className="ml-3"
                  />
                  <span className="text-red f12-400 d-block w-100 mb-2">
                    Online Offers
                  </span>
                  <span className="w-100 f9-400 d-block">
                    (Note: these offers can be only be used in your business
                    location offline)
                  </span>
                </div>
              </div>
              <hr />
              <div className="d-flex align-items-center">
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${selectedTab === 1 ? "active" : ""
                    }`}
                >
                  General Information
                </Button>
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${selectedTab === 2 ? "active" : ""
                    }`}
                >
                  Offer Settings
                </Button>
              </div>
              {selectedTab === 1 && (
                <Form>
                  <Row className="pt-4">
                    <Col lg={8}>
                      <Form.Group>
                        <TextField
                          // ref={nameee}
                          id="name"
                          label="Offer Name"
                          type="text"
                          variant="outlined"
                          className={`w-100 ${formik1.errors.name && formik1.touched.name
                            ? "enError"
                            : ""
                            }`}
                          name="name"
                          onChange={formik1.handleChange}
                          value={formik1.values.name}
                          onBlur={formik1.handleBlur}
                          isInvalid={
                            formik1.errors.name && formik1.touched.name
                          }
                        />
                        {formik1.errors.name && formik1.touched.name ? (
                          <div className="pho_14_regular text-danger">
                            {formik1.errors.name}
                          </div>
                        ) : null}
                      </Form.Group>
                      <Form.Group>
                        <TextField
                          // ref={description}
                          id="description"
                          label="Description"
                          type="text"
                          multiline
                          rows="5"
                          variant="outlined"
                          className={`w-100 ${formik1.errors.description &&
                            formik1.touched.description
                            ? "enError"
                            : ""
                            }`}
                          name="description"
                          onChange={formik1.handleChange}
                          value={formik1.values.description}
                          onBlur={formik1.handleBlur}
                          //onInvalid={formik1.errors.email && formik1.touched.email}
                          isInvalid={
                            formik1.errors.description &&
                            formik1.touched.description
                          }
                        />
                        {formik1.errors.description &&
                          formik1.touched.description ? (
                          <div className="pho_14_regular text-danger">
                            {formik1.errors.description}
                          </div>
                        ) : null}
                      </Form.Group>
                      <Row className="pb-4">
                        <Col lg={6}>
                          <div className="f12-400">
                            (Fill out the details , offers are used offline)
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="d-flex align-items-start">
                            <Switch
                              onChange={markAsPrimary(
                                primaryOffer.primaryOffer
                              )}
                              checked={primaryOffer.primaryOffer}
                              offColor="#EEEEEE"
                              onColor="#EEEEEE"
                              offHandleColor="#212121"
                              onHandleColor="#59F832"
                              handleDiameter={24}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              height={15}
                              width={41}
                              boxShadow="-2px 0px 5px #0000003B"
                              activeBoxShadow="-2px 0px 5px #0000003B"
                              id="material-switch"
                            />
                            <div className="pl-2">
                              <div className="f12-500 mb-2">
                                Make this Offer Primary
                              </div>
                              <div className="f10-400">
                                (Note you can make only one Offer primary, by
                                making this offer primary it will remove primary
                                from other active offers)
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={12}>
                      <hr />
                      <div className="font_20_b py-4">Offer Details</div>
                      <Row className="pb-4 align-items-center">
                        <Col md={3} xl={2} style={{ marginBottom: "30px" }}>
                          <TextField
                            id="start_date"
                            label="Start Date"
                            variant="outlined"
                            InputProps={{
                              inputProps: { min: minDate },
                            }}
                            type="date"
                            defaultValue={minDate}
                            className={`w-100 ${formik1.errors.start_date &&
                              formik1.touched.start_date
                              ? "enError"
                              : ""
                              }`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="start_date"
                            onChange={(e) => handleStartDateChange(e)}
                            //onChange={formik1.handleChange}
                            value={formik1.values.start_date}
                            onBlur={formik1.handleBlur}
                            //onInvalid={formik1.errors.email && formik1.touched.email}
                            isInvalid={
                              formik1.errors.start_date &&
                              formik1.touched.start_date
                            }
                          />
                          {formik1.errors.start_date &&
                            formik1.touched.start_date ? (
                            <div className="pho_14_regular text-danger">
                              {formik1.errors.start_date}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} xl={2} style={{ marginBottom: "30px" }}>
                          <TextField
                            id="start_time"
                            label="Start Time"
                            variant="outlined"
                            type="time"
                            className={`w-100 ${formik1.errors.start_time &&
                              formik1.touched.start_time
                              ? "enError"
                              : ""
                              }`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="start_time"
                            onChange={formik1.handleChange}
                            value={formik1.values.start_time}
                            onBlur={formik1.handleBlur}
                            isInvalid={
                              formik1.errors.start_time &&
                              formik1.touched.start_time
                            }
                          />
                          {formik1.errors.start_time &&
                            formik1.touched.start_time ? (
                            <div className="pho_14_regular text-danger">
                              {formik1.errors.start_time}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} xl={2} style={{ marginBottom: "30px" }}>
                          <TextField
                            id="end_date"
                            label="End Date"
                            variant="outlined"
                            InputProps={{
                              inputProps: { min: minEndDate },
                            }}
                            type="date"
                            className={`w-100 ${formik1.errors.end_date &&
                              formik1.touched.end_date
                              ? "enError"
                              : ""
                              }`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="end_date"
                            onChange={formik1.handleChange}
                            value={formik1.values.end_date}
                            onBlur={formik1.handleBlur}
                            isInvalid={
                              formik1.errors.end_date &&
                              formik1.touched.end_date
                            }
                          />
                          {formik1.errors.end_date &&
                            formik1.touched.end_date ? (
                            <div className="pho_14_regular text-danger">
                              {formik1.errors.end_date}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} xl={2} style={{ marginBottom: "30px" }}>
                          <TextField
                            id="end_time"
                            label="End Time"
                            variant="outlined"
                            type="time"
                            className={`w-100 ${formik1.errors.end_time &&
                              formik1.touched.end_time
                              ? "enError"
                              : ""
                              }`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="end_time"
                            onChange={formik1.handleChange}
                            value={formik1.values.end_time}
                            onBlur={formik1.handleBlur}
                            isInvalid={
                              formik1.errors.end_time &&
                              formik1.touched.end_time
                            }
                          />
                          {formik1.errors.end_time &&
                            formik1.touched.end_time ? (
                            <div className="pho_14_regular text-danger">
                              {formik1.errors.end_time}
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                      <Row className="pb-4 align-items-center">
                        <Col md={4} lg={4}>
                          <Form.Group>
                            <TextField
                              id="coupon_code"
                              label="Coupon Code"
                              type="text"
                              variant="outlined"
                              className={`w-100 ${formik1.errors.coupon_code &&
                                formik1.touched.coupon_code
                                ? "enError"
                                : ""
                                }`}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="coupon_code"
                              onChange={formik1.handleChange}
                              value={formik1.values.coupon_code}
                              onBlur={formik1.handleBlur}
                              isInvalid={
                                formik1.errors.coupon_code &&
                                formik1.touched.coupon_code
                              }
                            />
                            {formik1.errors.coupon_code &&
                              formik1.touched.coupon_code ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.coupon_code}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                        <Col md={3} lg={3}>
                          <Form.Group>
                            <NewInputText
                              extraClass="mb-1"
                              name="maximum_usage_limit"
                              maxLength={5}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onInput={maxLengthCheck}
                              inputType="number"
                              onKeyDown={InputNumberFunc}
                              onFocusOut={formik1.handleBlur}
                              onChange={formik1.handleChange}
                              value={formik1.values.maximum_usage_limit}
                              labelText="Maximum Usage Limit"
                              controlClass="maximum_usage_limit"
                            />
                            {formik1.errors.maximum_usage_limit &&
                              formik1.touched.maximum_usage_limit ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.maximum_usage_limit}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                        <Col md={4} lg={4}>
                          <div className="form-group d-flex align-items-center">
                            <div className="f18-500 mr-2">Status</div>
                            <div className="f12-400 mr-2">
                              {active.active ? "Active" : "Inactive"}
                            </div>
                            <Switch
                              onChange={toggleFunction}
                              checked={active.active}
                              offColor="#EEEEEE"
                              onColor="#EEEEEE"
                              offHandleColor="#212121"
                              onHandleColor="#59F832"
                              handleDiameter={24}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              height={15}
                              width={41}
                              boxShadow="-2px 0px 5px #0000003B"
                              activeBoxShadow="-2px 0px 5px #0000003B"
                              id="material-switch"
                            />
                          </div>
                        </Col>
                      </Row>
                      <hr />
                      <Row>
                        <Col md={12}>
                          <div className="event-offer-image">
                            <SimpleReactLightbox>
                              <MultipleImageUploadComponent
                                title="Add Photos*"
                                // smallTitle="(You can upload maximum 5 pic per event 700 x 420 pixels)"
                                onChange={uploadMultipleFiles}
                                stateValue={
                                  state.restaurant_pictures &&
                                  state.restaurant_pictures
                                }
                                newUploaded={
                                  state.restaurant_pictures_new
                                    ? state.restaurant_pictures_new
                                    : []
                                }
                                combined={state.combined}
                                onCompleteUploadMultipleCrop={
                                  onCompleteUploadMultipleCrop
                                }
                                removeImage={multipleResetFile}
                                accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                              // loader={state.multipleImageLoader}
                              />
                              <div className="font_12_r c_gray mb-4 d-flex">
                                (You can upload maximum 5 pic per event 700 x
                                420 pixels)
                              </div>
                            </SimpleReactLightbox>
                          </div>
                        </Col>
                        <Col md={12}>
                          <hr />
                        </Col>
                        <Col md={12}>
                          <div className="event-offer-image">
                            <SimpleReactLightbox>
                              <MultipleImageUploadComponent
                                title="Add Video"
                                onChange={uploadMultipleVideoFiles}
                                stateValue={
                                  state.video_url === ""
                                    ? []
                                    : [state.video_url]
                                }
                                const
                                removeImage={multipleVideoResetFile}
                                accept="video/*"
                                singleUpload={true}
                                videoUpload={true}
                              />
                              <div className="font_12_r c_gray mb-4 d-flex">
                                (You can upload only 1 pic per offer 700 x 420
                                pixels)
                              </div>
                            </SimpleReactLightbox>
                            {!state.progress && state.progress === 0 ? null : (
                              <AlertDialogProgress
                                progress={state.progress}
                                title="Video Uploading..."
                              />
                            )}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={8}>
                          <TextField
                            id="terms_and_condition"
                            label="Terms and Conditions"
                            type="text"
                            multiline
                            rows="5"
                            variant="outlined"
                            className={`w-100 ${formik1.errors.terms_and_condition &&
                              formik1.touched.terms_and_condition
                              ? "enError"
                              : ""
                              }`}
                            name="terms_and_condition"
                            onChange={formik1.handleChange}
                            value={formik1.values.terms_and_condition}
                            onBlur={formik1.handleBlur}
                            isInvalid={
                              formik1.errors.terms_and_condition &&
                              formik1.touched.terms_and_condition
                            }
                          />
                          {formik1.errors.terms_and_condition &&
                            formik1.touched.terms_and_condition ? (
                            <div className="pho_14_regular text-danger">
                              {formik1.errors.terms_and_condition}
                            </div>
                          ) : null}
                          <div className="py-2 f12-400 pb-5">
                            (Fill out the terms and conditions for offers are
                            used offline)
                          </div>
                          <Form.Group>
                            <TextField
                              id="refund_and_cancellation"
                              label="Refund & Cancellation"
                              type="text"
                              multiline
                              rows="5"
                              variant="outlined"
                              name="refund_and_cancellation"
                              className={`w-100 ${formik1.errors.refund_and_cancellation &&
                                formik1.touched.refund_and_cancellation
                                ? "enError"
                                : ""
                                }`}
                              onChange={formik1.handleChange}
                              value={formik1.values.refund_and_cancellation}
                              onBlur={formik1.handleBlur}
                              isInvalid={
                                formik1.errors.refund_and_cancellation &&
                                formik1.touched.refund_and_cancellation
                              }
                            />
                            {formik1.errors.refund_and_cancellation &&
                              formik1.touched.refund_and_cancellation ? (
                              <div className="pho_14_regular text-danger">
                                {formik1.errors.refund_and_cancellation}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                      </Row>
                      <div className="py-4 d-flex align-items-center">
                        <Button
                          variant="outline-secondary"
                          className="btn-lg mr-4 px-5 btn150px"
                          onClick={(e) => history.push("/offer")}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="danger"
                          className="btn-lg px-5 btn150px"
                          onClick={() => onClickSave()}
                        >
                          Next
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              )}
              {selectedTab === 2 && (
                <Form>
                  <div className="m-2" >
                    <label className="enCheckWithText small">
                      <div className={`f14-500`}>Do you want to make this as a Hidden Offer?</div>
                      <div className={`f10-400 text-grayLink`}>Specify user to avail this offer. This will not be visible under offer section</div>
                      <input
                        id="hidden"
                        type="checkbox"
                        name="hidden"
                        className="pt-2 pb-2"
                        value={
                          state.hidden
                        }
                        onClick={(e) => hiddenAction(!state.hidden)}
                        checked={state.hidden}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                  <div className="f16-500 pt-3 pb-5">Coupon Discount Type</div>
                  <Row className="checkbox-bank-account justify-content-start mb-4">
                    {percentArr.map((type, index) => {
                      return (
                        <Col md={3} key={index}>
                          <label className="enRadioWithText small">
                            <div className={`f14-500`}>{type.title}</div>
                            <input
                              id="isPercentage"
                              type="radio"
                              name="isPercentage"
                              onChange={() => isPercentageAction(type?.type)}
                              checked={
                                // formik2?.values?.isPercentage
                                formik2.values.type === type?.type
                                  ? true
                                  : false
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </Col>
                      );
                    })}
                  </Row>
                  {['PERCENTAGE', 'FIXED'].includes(formik2.values.type) &&
                    <>
                      <Row className="align-items-center pb-4">
                        <Col xs={8} md={2}>
                          <div className="d-flex align-items-center">
                            <NewInputText
                              extraClass="mb-1"
                              name="discount"
                              maxLength={formik2.values?.isPercentage ? 2 : 5}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onInput={maxLengthCheck}
                              inputType="number"
                              onKeyDown={InputNumberFunc}
                              onFocusOut={formik2.handleBlur}
                              onChange={formik2.handleChange}
                              value={formik2.values.discount}
                              labelText={
                                formik2.values?.isPercentage
                                  ? "Discount Percentage*"
                                  : "Discount Amount*"
                              }
                              controlClass="discount"
                              onpaste={(e) => e.preventDefault()}
                            />
                            <div className="f16-500 ml-2">
                              {formik2.values?.isPercentage ? "%" : "Rs."}
                            </div>
                          </div>
                          {formik2.errors.discount && formik2.touched.discount ? (
                            <div className="pho_14_regular text-danger">
                              {formik2.errors.discount}
                              {/* {formik2.errors.discount === "Discount Amount is required" ||
                  formik2.values?.isPercentage
                    ? "Discount Amount is required"
                    : "Fixed Amount is required"} */}
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                      <div className="f14-700 py-4">Minimum Order Value*</div>
                      <div className="row align-items-center pb-4">
                        <Col xs={8} md={2}>
                          <NewInputText
                            extraClass="mb-1"
                            name="minimum_order_applied"
                            maxLength={4}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onInput={maxLengthCheck}
                            inputType="number"
                            onKeyDown={InputNumberFunc}
                            onFocusOut={formik2.handleBlur}
                            onChange={formik2.handleChange}
                            value={formik2.values.minimum_order_applied}
                            labelText="Value"
                            controlClass="minimum_order_applied"
                            onpaste={(e) => e.preventDefault()}
                          />
                        </Col>
                        <div className="col-12">
                          {formik2.errors.minimum_order_applied &&
                            formik2.touched.minimum_order_applied ? (
                            <div className="pho_14_regular text-danger">
                              {formik2.errors.minimum_order_applied}
                            </div>
                          ) : (
                            <div className="f11-400 opacity5">
                              Enter minimum order value above which the offer can be
                              applied
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="f14-700 py-4">Maximum Order Value</div>
                      <div className="row align-items-center pb-4">
                        <Col xs={8} md={2}>
                          <NewInputText
                            extraClass="mb-1"
                            name="maximum_order_applied"
                            maxLength={4}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onInput={maxLengthCheck}
                            inputType="number"
                            onKeyDown={InputNumberFunc}
                            onFocusOut={formik2.handleBlur}
                            onChange={formik2.handleChange}
                            value={formik2.values.maximum_order_applied}
                            labelText="Value"
                            controlClass="maximum_order_applied"
                            onpaste={(e) => e.preventDefault()}
                          />
                        </Col>
                        <div className="col-12">
                          {formik2.errors.maximum_order_applied &&
                            formik2.touched.maximum_order_applied ? (
                            <div className="pho_14_regular text-danger">
                              {formik2.errors.maximum_order_applied}
                            </div>
                          ) : (
                            <div className="f11-400 opacity5">
                              Enter maximum order value above which the offer cannot
                              be applied
                            </div>
                          )}
                        </div>
                      </div>

                      {!formik2?.values?.isPercentage ? (
                        <></>
                      ) : (
                        <>
                          <div className="f14-700 py-4">
                            Maximum Discount Value*
                          </div>
                          <div className="row align-items-center pb-4">
                            <Col xs={8} md={2}>
                              <NewInputText
                                extraClass="mb-1"
                                name="maximum_discount_applied"
                                maxLength={4}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                onInput={maxLengthCheck}
                                inputType="number"
                                onKeyDown={InputNumberFunc}
                                onFocusOut={formik2.handleBlur}
                                onChange={formik2.handleChange}
                                value={formik2.values.maximum_discount_applied}
                                labelText="Value"
                                controlClass="maximum_discount_applied"
                                onpaste={(e) => e.preventDefault()}
                              />
                            </Col>
                            <div className="col-12">
                              {formik2.errors.maximum_discount_applied &&
                                formik2.touched.maximum_discount_applied ? (
                                <div className="pho_14_regular text-danger">
                                  {formik2.errors.maximum_discount_applied}
                                </div>
                              ) : (
                                <div className="f11-400 opacity5">
                                  Enter maximum discount value upto which discount
                                  can be availed
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      <hr />
                      <div className="f14-700 py-4">Applicable To Services</div>
                      <div className="w-100 mb-4">
                        {state.allRestaurantServices &&
                          state.allRestaurantServices.map((icon, index) => {
                            return icon.show ? (
                              <div
                                className={`btn f14-500 mr-3 cursor ${state.selectedRestaurantService.includes(
                                  icon?.name
                                )
                                  ? "onboarding_mapbutton_reusable_activesingle"
                                  : "onboarding_mapbutton_reusable_type"
                                  }`}
                                style={{
                                  border: `${state.selectedRestaurantService.includes(
                                    icon?.name
                                  )
                                    ? ""
                                    : "2px solid #212121"
                                    }`,
                                  color: `${state.selectedRestaurantService.includes(
                                    icon?.name
                                  )
                                    ? "#EE3A23"
                                    : "#212121"
                                    }`,
                                  minWidth: "110px",
                                  padding: "10px",
                                }}
                                key={index}
                                onClick={() => aplicableServices(icon, index)}
                                type="button"
                                title={icon.name}
                              >
                                {icon?.name}
                              </div>
                            ) : (
                              <></>
                            );
                          })}
                      </div>
                      <div className="col-12">
                        {formik2.errors.service_type &&
                          formik2.touched.service_type ? (
                          <div className="mb-3 pho_14_regular text-danger">
                            {formik2.errors.service_type}
                          </div>
                        ) : (
                          <div className="mb-3"> </div>
                        )}
                      </div>
                    </>
                  }

                  <div className="form-group d-flex align-items-center">
                    <div className="mr-4">
                      <div className={`f16-700`}>Discounted Delivery {['PERCENTAGE', 'FIXED'].includes(formik2.values.type) ? '(Optional)' : ""}</div>
                      <div className={`f10-400 text-grayLink`}>Offer discounted delivery upto a certain with this coupon on a minimum order value</div>
                    </div>
                    {['PERCENTAGE', 'FIXED'].includes(formik2.values.type) &&
                      <Switch
                        onChange={toggleDelivery}
                        checked={formik2.values.isDelivery}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={24}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={15}
                        width={41}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                      />}
                  </div>
                  <div className="f14-700 py-4">Minimum Order Value*</div>
                  <div className="row align-items-center pb-4">
                    <Col xs={8} md={2}>
                      <NewInputText
                        extraClass="mb-1"
                        name="deliveryMinOrder"
                        maxLength={4}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        onInput={maxLengthCheck}
                        inputType="number"
                        onKeyDown={InputNumberFunc}
                        onFocusOut={formik2.handleBlur}
                        onChange={formik2.handleChange}
                        value={formik2.values.deliveryMinOrder}
                        labelText="Value"
                        controlClass="deliveryMinOrder"
                        onpaste={(e) => e.preventDefault()}
                      />
                    </Col>
                    <div className="col-12">
                      {formik2.errors.deliveryMinOrder &&
                        formik2.touched.deliveryMinOrder ? (
                        <div className="pho_14_regular text-danger">
                          {formik2.errors.deliveryMinOrder}
                        </div>
                      ) : (
                        <div className="f11-400 opacity5">
                          Enter minimum order value above which the offer can be
                          applied
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="f14-700 py-4">Set Maximum User Discount on the delivery amount</div>
                  <div className="row align-items-center pb-4">
                    <Col xs={8} md={2}>
                      <NewInputText
                        extraClass="mb-1"
                        name="deliveryMaxDiscount"
                        maxLength={4}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        onInput={maxLengthCheck}
                        inputType="number"
                        onKeyDown={InputNumberFunc}
                        onFocusOut={formik2.handleBlur}
                        onChange={formik2.handleChange}
                        value={formik2.values.deliveryMaxDiscount}
                        labelText="Value"
                        controlClass="deliveryMaxDiscount"
                        onpaste={(e) => e.preventDefault()}
                      />
                    </Col>
                    <div className="col-12">
                      {formik2.errors.deliveryMaxDiscount &&
                        formik2.touched.deliveryMaxDiscount ? (
                        <div className="pho_14_regular text-danger">
                          {formik2.errors.deliveryMaxDiscount}
                        </div>
                      ) : (
                        <div className="f11-400 opacity5">
                          Specify the highest amount that can be discounted on the user's delivery amount
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="py-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 btn150px"
                      onClick={() => handleTab(1)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5 btn150px"
                      type="button"
                      onClick={() => onClickSave2()}
                    >
                      Save
                    </Button>
                  </div>
                </Form>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

VendorEditOnlineOffer.propTypes = {
  auth: PropTypes.object.isRequired,
  vendor_update_offer: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  onboarding: state?.onboarding?.restaurantDetails,
  subscriptionData:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
  servicesEnabled: state?.onboarding?.onboard_subscription_details
    ?.fast_food_dining
    ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
      ?.ordering
    : state?.onboarding?.onboard_subscription_details?.casual_dining
      ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.ordering
      : state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status?.ordering,
  sessionSettings:
    state?.onboarding &&
    state?.onboarding?.restaurantDetails &&
    state?.onboarding?.restaurantDetails?.orderSessionSettings,
});

export default connect(mapStateToProps, {
  vendor_update_offer,
})(VendorEditOnlineOffer);
